export enum PublishedConnectionExtractRefreshLevel {
  Table = 'Table',
  Database = 'Database'
}
